// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"5ce554e5","131":"4145bc11","172":"305db8fb","303":"93d8aa20","419":"fa4eb55b","434":"c6669396","469":"70ec825a","675":"0fa820c3","726":"56c05ec2","890":"1fb0b91e"}[chunkId] + ".chunk.js";
};